const icon = require('vue-svgicon');
icon.register({
    'facebook-round': {
        width: 32,
        height: 32,
        viewBox: '0 0 32 32',
        data: `<path pid="0" d="M16 0C7.178 0 0 7.178 0 16s7.178 16 16 16c8.823 0 16-7.177 16-16S24.822 0 16 0zm0 31.17C7.635 31.17.83 24.365.83 16S7.635.83 16 .83 31.17 7.635 31.17 16 24.365 31.17 16 31.17z"/><path pid="1" d="M20.286 16.378h-3.201v8.609h-3.69v-8.609h-1.778v-2.816h1.778v-1.829c0-2.486 1.072-3.964 3.994-3.964h3.368v3.047h-2.75c-.816-.001-.917.426-.917 1.221l-.004 1.525h3.689l-.488 2.816z"/>`,
    },
});
